import React from "react";
import { useLocation } from "react-router-dom";
import images from "../../../images";

function StoryPost() {
    // const navigate = useNavigate();
    const location = useLocation();
    const { responseAnswer } = location.state || {};
    const token = responseAnswer?.data?.add_token || 0;

    const tokenToUSD = (token) => {
        return `$${(token * 0.01).toFixed(2)}`;
    };

    return (
        <div className="flex flex-col items-center bg-[#253FF6] max-w-[480px] w-full min-h-screen mx-auto overflow-hidden text-white">
            {/* Main Content */}
            <div className="relative px-6 pt-[104px] flex flex-col items-start w-full">
                {/* Title */}
                <h1 className="text-6xl  font-bold tracking-tight">
                    Ate a salad <br /> and pocketed <br /> some cash
                </h1>

                <img
                    src={images.LightningLeft}
                    alt=""
                    className="absolute w-3 h-6 top-[60px] right-40"
                />
                <img
                    src={images.LightningRight}
                    alt=""
                    className="absolute top-[85px] right-[74px] w-5 h-5 "
                />
                <img
                    src={images.Star}
                    alt=""
                    className="absolute w-14 h-[51px] top-8 right-3"
                />
                <img
                    src={images.Lightning}
                    alt=""
                    className="absolute w-4 h-7 top-36 right-3"
                />
            </div>

            {/* Mid Icons */}
            <div className="flex flex-1 justify-between flex-row mt-12 w-full items-start gap-16">
                {/* Money Bag */}
                <img
                    src={images.Earning1}
                    alt="earning"
                    className=" w-[92px] ml-5 object-cover -mt-7"
                />

                {/* Food Image */}
                <img
                    src={images.Thumnail3}
                    alt="salad"
                    className="w-[276px] h-[274px] rounded-l-md object-cover"
                />
            </div>

            {/* Bottom Section */}
            <div className="w-full px-6 pt-8 pb-8 relative">
                {/* Reward Line */}
                <div className="mb-6">
                    <div className="flex items-baseline gap-3">
                        <span className="text-[64px] font-bold leading-none">
                            {token}
                        </span>
                        <div className="flex items-center gap-1">
                            <div className="w-11 h-11 flex items-center justify-center">
                                <img
                                    src={images.RallyCointWhite}
                                    alt="rally coin"
                                />
                            </div>
                            <span className="text-white mt-5 ml-2 text-2xl font-bold">
                                = {tokenToUSD(token)}
                            </span>
                        </div>
                    </div>
                    <div className="text-white mt-4 text-3xl font-bold leading-9">
                        earned by mystery dining <br /> on Rally!
                    </div>
                </div>

                {/* RALLY Logo */}
                <div className="flex justify-between mt-20 items-center">
                    <img
                        src={images.RallyLogo}
                        alt="Rally Logo"
                        className="h-4 object-contain"
                    />

                    {/* Bottom-right Character */}
                    <img
                        src={images.TipQuestion}
                        alt="character"
                        className="absolute bottom-4 right-4 w-[124px] h-auto object-contain"
                    />
                </div>
            </div>
        </div>
    );
}

export default StoryPost;
